var _getLowCodeCoreUtil;
import Icon from "./logo";
import { createBlockInitialChildrenSnippet, createDefaultFilter, createSectionInitialChildren, getComponentSlotSetterSnippet, getObjectSetterSnippet } from "../../common/manager/setter-snippet";
import { ColumnsLayoutSetter } from '@ali/visualengine-utils';
import { getLowCodeCoreUtil, hasCnLayoutPage } from "../../common/util/util";
import { BLOCK } from "../../common/util/const";
import { updateSpan } from "../cn-layout-cell/components/split/auto-block";
var CnLayoutSectionPrototype = {
  title: '自由布局容器',
  componentName: 'CnLayoutSection',
  category: '高级',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  initialChildren: createSectionInitialChildren,
  didDropOut: function didDropOut(removedNode) {
    updateSpan({
      parent: removedNode.parent,
      child: removedNode,
      type: 'delete'
    });
  },
  snippets: [{
    screenshot: 'https://img.alicdn.com/imgextra/i4/O1CN01lrzpI11ueRo9jGONo_!!6000000006062-0-tps-2048-674.jpg',
    label: 'CnLayoutSection',
    schema: {
      componentName: 'CnLayoutSection',
      props: {}
    }
  }],
  configure: [{
    name: 'isCnLayoutSection',
    title: 'CnLayoutSection',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }, {
    title: '布局',
    name: '_layout',
    display: 'accordion',
    collapsed: false,
    setter: getObjectSetterSnippet({
      items: [{
        name: 'layout',
        display: 'plain',
        defaultValue: '6:6',
        extraProps: {
          getValue: function getValue(target, value) {
            var _target$getNode, _node$getChildren, _children$map, _list$join;
            var node = target === null || target === void 0 ? void 0 : (_target$getNode = target.getNode) === null || _target$getNode === void 0 ? void 0 : _target$getNode.call(target);
            var children = node === null || node === void 0 ? void 0 : (_node$getChildren = node.getChildren) === null || _node$getChildren === void 0 ? void 0 : _node$getChildren.call(node);
            var list = children === null || children === void 0 ? void 0 : (_children$map = children.map) === null || _children$map === void 0 ? void 0 : _children$map.call(children, function (child) {
              var _child$getPropValue;
              return child === null || child === void 0 ? void 0 : (_child$getPropValue = child.getPropValue) === null || _child$getPropValue === void 0 ? void 0 : _child$getPropValue.call(child, 'span');
            });
            return list === null || list === void 0 ? void 0 : (_list$join = list.join) === null || _list$join === void 0 ? void 0 : _list$join.call(list, ':');
          },
          setValue: function setValue(target, value) {
            var _target$getNode2;
            var size = value === null || value === void 0 ? void 0 : value.split(':').length;
            var list = value === null || value === void 0 ? void 0 : value.split(':');
            var node = target === null || target === void 0 ? void 0 : (_target$getNode2 = target.getNode) === null || _target$getNode2 === void 0 ? void 0 : _target$getNode2.call(target);
            node.mergeChildren(function (child, index) {
              child.setPropValue('span', +(list === null || list === void 0 ? void 0 : list[index]) || 1);
              return index >= size;
            }, function (children) {
              var l = children.length;
              var items = [];
              while (l++ < size) {
                var _target$getNode3, _target$getNode3$call, _target$getNode3$call2, _target$getNode3$call3;
                items.push({
                  componentName: BLOCK,
                  props: {
                    span: +(list === null || list === void 0 ? void 0 : list[l - 1]) || 1
                  },
                  children: [createBlockInitialChildrenSnippet(target === null || target === void 0 ? void 0 : (_target$getNode3 = target.getNode) === null || _target$getNode3 === void 0 ? void 0 : (_target$getNode3$call = _target$getNode3.call(target)) === null || _target$getNode3$call === void 0 ? void 0 : (_target$getNode3$call2 = _target$getNode3$call.propsData) === null || _target$getNode3$call2 === void 0 ? void 0 : (_target$getNode3$call3 = _target$getNode3$call2.normalStyle) === null || _target$getNode3$call3 === void 0 ? void 0 : _target$getNode3$call3.defaultCardStyle)]
                });
              }
              return items;
            }, null);
          }
        },
        setter: /*#__PURE__*/React.createElement(ColumnsLayoutSetter, null)
      }, getComponentSlotSetterSnippet({
        title: '开启筛选栏插槽',
        slotInitialValue: {
          type: "JSSlot",
          value: [createDefaultFilter()]
        }
      })]
    })
  }, {
    title: '样式',
    name: 'normalStyle',
    display: 'accordion',
    collapsed: false,
    setter: getObjectSetterSnippet({
      initialValue: function initialValue() {
        return {
          title: '布局容器标题',
          defaultCardStyle: hasCnLayoutPage() ? 'CnTile' : 'CnCard'
        };
      },
      items: [{
        name: 'title',
        title: '标题',
        display: 'inline',
        defaultValue: '布局容器标题',
        setter: 'CnI18nSetter'
      }, {
        name: 'defaultCardStyle',
        title: '默认卡片样式',
        display: 'inline',
        setter: {
          componentName: 'SelectSetter',
          props: {
            options: [{
              label: '卡片（FTP、表单场景使用）',
              value: 'CnCard'
            }, {
              label: '瓷片（DashBoard场景中使用）',
              value: 'CnTile'
            }, {
              label: '空',
              value: 'Blank'
            }]
          }
        }
      }, {
        name: 'noPadding',
        title: '关闭内边距',
        display: 'inline',
        setter: 'BoolSetter'
      }]
    })
  }, {
    name: 'extra',
    title: '右侧按钮栏',
    display: 'accordion',
    setter: (_getLowCodeCoreUtil = getLowCodeCoreUtil('button.createButtonListSetters')) === null || _getLowCodeCoreUtil === void 0 ? void 0 : _getLowCodeCoreUtil({
      position: getLowCodeCoreUtil('enumMap.ButtonPosition.tileRightButton')
    })
  }, {
    title: '高级配置',
    type: 'group',
    collapsed: true,
    display: 'accordion',
    items: [{
      name: 'handleProps',
      title: '手动设置组件props',
      display: 'inline',
      setter: {
        title: '写js表达式',
        componentName: 'CnRowDataSetter',
        props: function props() {
          return {
            list: [],
            initialCode: "(oldProps, state) => {\n  // \u7ED9\u7EC4\u4EF6\u8BBE\u7F6E\u65B0\u7684props\u3002\n  // oldProps.xxx = 'xxx'\n  // return oldProps;\n}",
            tip: "\noldProps: \u7EC4\u4EF6\u7684\u539F\u59CBoldProps\nstate\uFF1A\u5168\u90E8\u7684\u6570\u636E\uFF0C\u5728\u5DE6\u4FA7\u5217\u8868\u4E2D\u9009\u62E9\u4F7F\u7528\u3002\n"
          };
        }
      }
    }]
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutSectionPrototype };